import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "./firebase/index.js";

export interface SubmitQuoteLeadRequest {
  clientId: string;
  customerName: string;
  customerEmail: string;
  customerPhone?: string;
  subject: string;
  fields: { label: string; value: string }[];
  confirmationMessage?: string;
}

/** Submit a quote lead — creates the Jobber customer and sends both emails. */
export async function submitQuoteLead(
  req: SubmitQuoteLeadRequest,
): Promise<{ success: boolean; jobberSynced: boolean }> {
  const fn = httpsCallable<SubmitQuoteLeadRequest, { success: boolean; jobberSynced: boolean }>(
    getFirebaseFunctions(),
    "submitQuoteLead",
  );
  const result = await fn(req);
  return result.data;
}

/** Disconnect the Jobber integration for a client. Public — no Firebase Auth required. */
export async function disconnectJobber(clientId: string): Promise<void> {
  const fn = httpsCallable<{ clientId: string }, { success: boolean }>(
    getFirebaseFunctions(),
    "disconnectJobber",
  );
  await fn({ clientId });
}
